/**
 * RowControls — keyboard-native reorder (▲/▼) + remove (✕) for the dynamic
 * lists. Up/down buttons (not drag) so it's reduced-motion-safe and operable
 * by keyboard. Pass onMove to enable reordering; omit it for unordered lists.
 */
export function RowControls({ index, count, onMove, onRemove, label }) {
  return (
    <div className="admin-flow-row-controls">
      {onMove && (
        <>
          <button
            type="button"
            className="admin-aim-icon-btn"
            disabled={index === 0}
            onClick={() => onMove(-1)}
            aria-label={`Move ${label} up`}
            title="Move up"
          >
            ▲
          </button>
          <button
            type="button"
            className="admin-aim-icon-btn"
            disabled={index === count - 1}
            onClick={() => onMove(1)}
            aria-label={`Move ${label} down`}
            title="Move down"
          >
            ▼
          </button>
        </>
      )}
      <button
        type="button"
        className="admin-aim-icon-btn admin-flow-remove"
        onClick={onRemove}
        aria-label={`Remove ${label}`}
        title="Remove"
      >
        ✕
      </button>
    </div>
  )
}
